import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/common/helpers/api-helper";
import JobCategoryApi from "@infrastructure/jobcategory-api";
import { addSuccessNotification } from "../common/notificationSlice";
export const getAllJobCategoriesAsync = createAsyncThunk('Job/GetAllJobCategories', async (_, { rejectWithValue }) => {
    try {
        const response = await JobCategoryApi.getAllJobCategories();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createJobCategoryAsync = createAsyncThunk('Job/CreateJobCategory', async (employeeHourType, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await JobCategoryApi.createJobCategory(employeeHourType);
        dispatch(addSuccessNotification('Werkorder Categorieen succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateJobCategoryAsync = createAsyncThunk('Job/UpdateJobCategory', async (jobCategory, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await JobCategoryApi.updateJobCategory(jobCategory);
        dispatch(addSuccessNotification('Werkorder Categorieen succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getJobCategoryByIdAsync = createAsyncThunk('Job/GetJobCategoryById', async (jobCategory, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await JobCategoryApi.getJobCategoryById(jobCategory);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
